import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from '@sainsburys-tech/bolt';
import * as Styled from './AvailabilityFilters.styles';
var PROP_TYPES = {
  filters: PropTypes.array.isRequired,
  activeFilter: PropTypes.object,
  toggleFilter: PropTypes.func
};
var DEFAULT_PROPS = {
  activeFilter: {
    id: null
  }
};

var AvailabilityFilters = function AvailabilityFilters(_ref) {
  var filters = _ref.filters,
      activeFilter = _ref.activeFilter,
      toggleFilter = _ref.toggleFilter;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.Paragraph, null, "When do you want it?"), /*#__PURE__*/React.createElement(Styled.Buttons, null, /*#__PURE__*/React.createElement(Tabs, {
    toggleTabCallback: toggleFilter
  }, filters.map(function (filter) {
    var id = filter.id,
        label = filter.label;
    var isActive = activeFilter.id === id && activeFilter.label === label;
    return /*#__PURE__*/React.createElement(Tab, {
      isActive: isActive,
      label: label,
      key: id + label
    });
  }))));
};

AvailabilityFilters.propTypes = PROP_TYPES;
AvailabilityFilters.defaultProps = DEFAULT_PROPS;
export default AvailabilityFilters;